import { isValid } from 'date-fns';
import { checkVAT, countries } from 'jsvat-next';

import { toAmount } from 'src/core/utils/money';

const Validations = {
  validateAmount(amount: number | null | undefined) {
    const clearedAmount = toAmount(amount);
    // FIXME: Don't use isNaN
    // eslint-disable-next-line no-restricted-globals, unicorn/prefer-number-properties
    return typeof clearedAmount === 'number' && !isNaN(clearedAmount);
  },
  validatePositiveAmount(amount: number | null | undefined) {
    // @ts-expect-error validateAmount makes sure that it is defined
    return Validations.validateAmount(amount) && amount > 0;
  },
  validateEmail(email: string | null) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email ?? '');
  },
  validateDateRange(dateRange = '') {
    const [from, to] = dateRange.split('/');
    return isValid(new Date(from)) && isValid(new Date(to));
  },
  validateVat(vat: string | undefined | null) {
    if (!vat) {
      return true;
    }

    return checkVAT(vat, countries).isValid;
  },
  validateDomain(domain: string) {
    const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return domainPattern.test(domain);
  },
};

export default Validations;
